/**
 * Подключение движка синхронизации к состоянию приложения.
 *
 * Разделено с bootstrap, чтобы стартовая последовательность читалась
 * как последовательность, а не как клубок обработчиков.
 */
import type { EngineCallbacks } from '@shared/sync/engine'

import { useAppStore } from '../model/app-store'
import { emitInAppEvent } from '../model/in-app-events'
import { refreshMe } from './refresh-me'
import { handleSessionLost } from './session-lifecycle'

export function attachEngineCallbacks(): EngineCallbacks {
  const store = () => useAppStore.getState()

  return {
    /*
     * §8.6: внутренний баннер N-06 — новое сообщение другого диалога и новый
     * match. Только в установившемся режиме: события догона (SYS-11) описывают
     * то, что произошло, пока приложение было закрыто, и баннерами не являются.
     */
    onEffects: (effects) => {
      const status = store().syncStatus
      if (status !== 'live' && status !== 'polling_fallback') return

      if (effects.incomingMessage) emitInAppEvent({ kind: 'message', message: effects.incomingMessage })
      if (effects.matchCreated) emitInAppEvent({ kind: 'match', match: effects.matchCreated })
    },

    onStatusChange: (status) => {
      store().setSyncStatus(status)

      // CC §3.2: online — это успешный обмен с сервером, а не navigator.onLine.
      if (status === 'live' || status === 'polling_fallback') store().setOnline(true)
    },

    onSessionLost: () => {
      void handleSessionLost()
    },

    onConsentRequired: () => {
      store().setBlocking({ kind: 'consent_required' })
    },

    onForbidden: () => {
      // 4403: причина выясняется через GET /me — consent, onboarding или Origin.
      void refreshMe()
    },
  }
}
